import { render, staticRenderFns } from "./AcceleratorProfile.vue?vue&type=template&id=bdda39cc&scoped=true&"
import script from "./AcceleratorProfile.vue?vue&type=script&lang=js&"
export * from "./AcceleratorProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdda39cc",
  null
  
)

export default component.exports